import React from "react";
import Profile from "../../assets/icons/user-avatar.svg";
import { useSelector } from "react-redux";

const ProfileIcon = ({ isOpen, className = "", size = "w-10 h-10" }) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <button
      className={`${size} relative overflow-hidden cursor-pointer ${className}`}
      aria-label="Profile menu"
      aria-expanded={isOpen}
      aria-haspopup="true"
      type="button"
    >
      <img
        src={user?.profileImage || Profile}
        alt="Profile"
        className="h-8 absolute top-1 object-cover"
      />
    </button>
  );
};

export default ProfileIcon;
